import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleFieldConfig } from '../simple-field.interface';

@Component({
  selector: "app-button",
  template: `
<div fxFlex="100" [formGroup]="group" style="width: 100%;">
<button type="submit" mat-raised-button class="primary" style="width: 100%;">{{field.label}}</button>
</div>
`,
  styles: []
})
export class ButtonComponent implements OnInit {
  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}
